import { Paper, Tab, Tabs, Select, MenuItem, FormControl, useMediaQuery } from "@mui/material";

const LABELS = [
  { label: "Event Alert(s)", value: "event" },
  { label: "Expiry Alert(s)", value: "expiry" },
  { label: "Custom Alert(s)", value: "custom" },
];

const AlertTabs = ({ value, onChangeTab }) => {
  const isMobile = useMediaQuery('(max-width: 600px)');
  const isTabletPortrait = useMediaQuery('(min-width: 768px) and (max-width: 1024px) and (orientation: portrait)');
  const showDropdown = isMobile || isTabletPortrait;

  const handleSelectChange = (e) => {
    onChangeTab(e, e.target.value);
  };

  if (showDropdown) {
    return (
      <FormControl size="small" className="rental-mob-dropdown">
        <Select value={value} onChange={handleSelectChange} className="mob-dropdown">
          {LABELS.map((item) => (
            <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  return (
    <Paper className="alert-tabs-paper">
      <Tabs className="reserve-rate-invoice-tab" value={value} onChange={onChangeTab}>
        {LABELS.map((item) => (
          <Tab key={item.value} label={item.label} value={item.value} />
        ))}
      </Tabs>
    </Paper>
  );
};

export default AlertTabs;
